import { faCube } from '@fortawesome/pro-light-svg-icons';
import { faCube as faCubeSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppLayout } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import { NavigationRailDestination } from '~/components/atoms/NavigationRailDestination/NavigationRailDestination';

export type IPersonalNavigationRailContentProps = IContainerProps & {
  //
};

export const PersonalNavigationRailContent: React.FC<
  IPersonalNavigationRailContentProps
> = (props) => {
  const { ...other } = props;
  const { t } = useTranslation();

  return (
    <AppLayout.NavigationRail divider {...other}>
      <NavigationRailDestination
        icon={<FontAwesomeIcon icon={faCube} fixedWidth />}
        activeIcon={<FontAwesomeIcon icon={faCubeSolid} fixedWidth />}
        href="/apps"
        label={t('PersonalNavigationRailContent.applications')}
      />
    </AppLayout.NavigationRail>
  );
};
